import { MainThunkDispatch } from "../../Reducers"
import { failMessage, successMessage } from "../Client/MessagesActions"
import { ContactUsMessageModel } from "../../Models/External/FeedbackModel"
import { safePromise } from "../../Helpers/Functions/promise"
import { apiFetch } from "../Client/NetworkActions"
import { apiEndpoints } from "../../Routes/api"

export const sendContact =
    (data: any, successText?: string, errorText?: string) =>
    async (dispatch: MainThunkDispatch) => {
        const { error } = await safePromise(
            dispatch(
                apiFetch(`SEND_CONTACT`, apiEndpoints.contact({}), {
                    method: "POST",
                    body: JSON.stringify(data)
                })
            )
        )

        if (error !== undefined) {
            if (errorText) dispatch(failMessage(errorText, error))
            return
        }

        if (successText) dispatch(successMessage(successText))
    }

export const sendContactUsMessage =
    ({
        title,
        email,
        phone,
        company,
        message,
        extraData: { type, ...extraData }
    }: ContactUsMessageModel) =>
    async (dispatch: MainThunkDispatch) => {
        await dispatch(
            sendContact(
                {
                    title: title ?? `Dash Customer Contact (${type})`,
                    phone,
                    company,
                    email,
                    description: Object.entries({ message, ...extraData })
                        .map(([k, v]) => `# ${k}\r\n${v}`)
                        .join("\r\n\r\n")
                },
                "Your message has been sent",
                "Could not send message"
            )
        )
    }
